import * as React from "react";
import { Client } from "src/domain/model/client";
import { Company } from "src/domain/model/company";
import { Contract } from "src/domain/model/contract";
import styled, { css } from "styled-components";
import {
  ConstBreakPoint,
  ConstColor,
  ConstZIndex,
} from "../../../../config/styles_const/styles_const";
import { MessageRoomsEmpty } from "../../../../config/view_const/message_rooms";
import EmptyData from "../../../common/organism/empty_data";
import Progress from "../../../common/organism/progress";
import { IAppNotificationMessageDispatcher } from "../../../dispatcher/app_notification_message_dispatcher";
import { IClientMessageRoomDispatcher } from "../../../dispatcher/client_message_room_dispatcher";
import { IClientMessageRoomsDispatcher } from "../../../dispatcher/client_message_rooms_dispatcher";
import { ClientMessageRoomState } from "../../../store/client_message_room_state";
import { ClientMessageRoomsState } from "../../../store/client_message_rooms_state";
import ClientMessageRoomsLeft from "./left/client_message_rooms_left";
import ClientMessageRoomsMain from "./main/client_message_rooms_main";
import ClientMessageRoomsRight from "./right/client_message_rooms_right";

interface IProps {
  messageRoomsState: ClientMessageRoomsState;
  messageRoomState: ClientMessageRoomState;
  messageRoomsDispatcher: IClientMessageRoomsDispatcher;
  messageRoomDispatcher: IClientMessageRoomDispatcher;
  notificationDispatcher: IAppNotificationMessageDispatcher;
  contracts: Contract[];
  isInit: boolean;
  match: any;
  company: Company;
  client: Client;
}

const ClientMessageRoomsComponent: React.FC<IProps> = (props) => {
  const {
    messageRoomsState,
    messageRoomsDispatcher,
    messageRoomState,
    messageRoomDispatcher,
    notificationDispatcher,
    contracts,
    isInit,
    match,
    company,
    client,
  } = props;
  const { initialMessageRoom, messageRooms } = messageRoomsState;

  const { projectId, customerId } = match.params;

  const isMessageRooms = !(projectId && customerId);

  // 初期化
  if (isInit) {
    return <Progress canAnimation={false} />;
  }

  return (
    <MessageRoomsWrapper>
      {messageRooms.length === 0 && (
        <EmptyData
          main={MessageRoomsEmpty.messageRoomsForClientMainText}
          description={MessageRoomsEmpty.messageRoomsForClientDescriptionText}
          linkUrl={`/client/projects`}
          btnText={MessageRoomsEmpty.messageRoomsForClientBtnText}
        />
      )}
      <Wrapper>
        <LeftWrapper isMessageRooms={isMessageRooms}>
          <ClientMessageRoomsLeft
            messageRoomsState={messageRoomsState}
            messageRoomsDispatcher={messageRoomsDispatcher}
            isMessageRooms={isMessageRooms}
          />
        </LeftWrapper>
        <MainWrapper isMessageRooms={isMessageRooms}>
          <ClientMessageRoomsMain
            messageRoomState={messageRoomState}
            messageRoomDispatcher={messageRoomDispatcher}
            initialMessageRoom={initialMessageRoom}
            notificationDispatcher={notificationDispatcher}
            contracts={contracts}
            match={match}
            company={company}
            client={client}
          />
        </MainWrapper>
        <RightWrapper>
          <ClientMessageRoomsRight messageRoomState={messageRoomState} />
        </RightWrapper>
      </Wrapper>
    </MessageRoomsWrapper>
  );
};

export default ClientMessageRoomsComponent;

const MessageRoomsWrapper = styled.div`
  padding-top: 10px;
  @media screen and (min-width: ${ConstBreakPoint.Default}) {
    display: flex;
    flex-direction: column;
    height: calc(100vh - 60px);
  }
`;

const Wrapper = styled.div`
  display: flex;
  @media screen and (min-width: ${ConstBreakPoint.Default}) {
    flex-grow: 1;
    flex-basis: 0;
    overflow: hidden;
  }
`;

const LeftWrapper = styled.div<{ isMessageRooms: boolean }>`
  width: 100%;
  z-index: ${ConstZIndex.menu};
  padding-left: 10px;
  padding-right: 10px;
  ${(props) =>
    !props.isMessageRooms &&
    css`
      display: none;
    `}
  @media screen and (min-width: ${ConstBreakPoint.Default}) {
    display: block;
    overflow: auto;
    width: 300px;
    border-right: 1px solid ${ConstColor.PlaceholderAndBorder};
  }
`;

const MainWrapper = styled.div<{ isMessageRooms: boolean }>`
  flex: 1;
  ${(props) =>
    props.isMessageRooms &&
    css`
      display: none;
    `}
  @media screen and (min-width: ${ConstBreakPoint.Default}) {
    display: block;
    overflow: auto;
  }
`;

const RightWrapper = styled.div`
  display: none;
  border-left: 1px solid ${ConstColor.PlaceholderAndBorder};
  @media screen and (min-width: ${ConstBreakPoint.PcDeskTop}) {
    display: block;
    width: 280px;
    padding-left: 20px;
    padding-right: 20px;
    overflow: auto;
  }
`;



// WEBPACK FOOTER //
// ./src/presentation/component/client/message_rooms/client_message_rooms.tsx